/** About the open picker panel's height: the field, the filter, a full list and the note. */
const PANEL_HEIGHT_PIXELS = 460;

/**
 * Where the picker's panel opens: below its button, unless there is too little room below
 * and more above, as for a Thread's composer at the foot of a long Thread.
 */
export function sideWithRoom(top: number, bottom: number, viewportHeight: number): "below" | "above" {
  const below = viewportHeight - bottom;
  return below < PANEL_HEIGHT_PIXELS && top > below ? "above" : "below";
}
